import type { User } from "@/types/user";
import React from "react";

export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export type AuthContextData = {
  user: User | null;
  authStatus: AuthStatus;
  loading: boolean;
  isAuthenticated: boolean;
  error: string | null;
  setUser: (user: User | null) => void;
  login: (user: User) => void;
  logout: (options?: {
    redirectTo?: string;
    callServer?: boolean;
    stayLoggedOut?: boolean;
  }) => Promise<void>;
  refresh: () => Promise<User | null>;
};

export const AuthContext = React.createContext<AuthContextData | null>(null);
